import React from 'react';
import { Link } from 'react-router-dom';
function CollegeAll() {
    return (
        <div className="college-all">
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-lg-12 text-center mb-5">
                        <h1 className="display-4 font-weight-bold">Collegeall Dashboard</h1>
                        <p className="lead text-muted">Manage Universities and Courses easily</p>
                    </div>

                    <div className="col-lg-3 col-md-4 mb-4">
                        <div className="card shadow-lg border-light">
                            <div className="card-body text-center">
                                <Link to="/website/collegeall/edituniversities">
                                    <button className="btn btn-edit-university btn-lg px-4 py-2 w-100">
                                        Edit University
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 mb-4">
                        <div className="card shadow-lg border-light">
                            <div className="card-body text-center">
                                <Link to="/website/collegeall/editcourse">
                                    <button className="btn btn-edit-course btn-lg px-4 py-2 w-100">
                                        Edit Course
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 mb-4">
                        <div className="card shadow-lg border-light">
                            <div className="card-body text-center">
                                <Link to="/website/view-lead">
                                    <button className="btn btn-view-lead btn-lg px-4 py-2 w-100">
                                        View Lead
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 mb-4">
                        <div className="card shadow-lg border-light">
                            <div className="card-body text-center">
                                <Link to="/website/get-utm-link">
                                    <button className="btn btn-utm-link btn-lg px-4 py-2 w-100">
                                        Get UTM link
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-4 mb-4">
                        <div className="card shadow-lg border-light">
                            <div className="card-body text-center">
                                <Link to="/website/create-users">
                                    <button className="btn btn-create-users btn-lg px-4 py-2 w-100">
                                        Create the Users
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CollegeAll;
